<div class="process-table">
  <!-- Material Cost -->
  <table>
    <thead>
      <tr>
        <th [attr.colspan]="16 - this.displayedColumns?.length">
          Product Code | Description
        </th>
        <th *ngIf="displayedColumns.includes('pkgs')" class="width-100">
          <div>PKG's</div>
        </th>
        <th *ngIf="displayedColumns.includes('qtyReq')" class="width-100">
          <div>QTY Req.</div>
        </th>
        <th *ngIf="displayedColumns.includes('qoh')" class="width-100">
          <div>QOH</div>
        </th>
        <th
          *ngIf="displayedColumns.includes('prevPurchaseDates')"
          class="width-100"
        >
          <div>Prev. Purchase Dates</div>
        </th>
        <th *ngIf="displayedColumns.includes('prevQty')" class="width-100">
          <div>Prev. QTY</div>
        </th>
        <th *ngIf="displayedColumns.includes('prevPrice')" class="width-100">
          <div>Prev. Price</div>
        </th>
        <th *ngIf="displayedColumns.includes('prevVendor')" class="width-100">
          <div>Prev. Vendor #</div>
        </th>
        <th
          *ngIf="displayedColumns.includes('weight')"
          class="width-100 weight number-column"
        >
          <div>
            WT/SKU ({{
              productPackages?.controls[0]
                ?.get("weight")
                .get("userConversionUom").value
            }})
          </div>
        </th>
        <th
          *ngIf="displayedColumns.includes('volume')"
          class="width-100 volume number-column"
        >
          <div>
            VOL/SKU ({{
              productPackages?.controls[0]
                ?.get("volume")
                .get("userConversionUom").value
            }})
          </div>
        </th>
        <th
          *ngIf="displayedColumns.includes('skuPrice')"
          class="width-120 number-column"
        >
          <div>
            SKU PRICE ({{
              productPackages?.controls[0]?.get("cost").get("userConversionUom")
                .value
            }})
          </div>
        </th>
        <th
          *ngIf="displayedColumns.includes('qtySkus')"
          class="width-125 text-center"
        >
          <span>QTY SKUS </span>
        </th>
        <th
          *ngIf="displayedColumns.includes('subTotal')"
          class="width-125 number-column"
        >
          <div>
            Sub Total ({{
              productPackages?.controls[0]
                ?.get("totalCost")
                .get("userConversionUom").value
            }})
          </div>
        </th>
        <th *ngIf="displayedColumns.includes('action')">
          <span>ACTION</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="productPackages?.controls?.length == 0">
        <tr>
          <td [attr.colspan]="16 - this.displayedColumns?.length"></td>
          <td *ngIf="displayedColumns.includes('pkgs')"></td>
          <td *ngIf="displayedColumns.includes('qtyReq')"></td>
          <td *ngIf="displayedColumns.includes('qoh')"></td>
          <td *ngIf="displayedColumns.includes('prevPurchaseDates')"></td>
          <td *ngIf="displayedColumns.includes('prevQty')"></td>
          <td *ngIf="displayedColumns.includes('prevPrice')"></td>
          <td *ngIf="displayedColumns.includes('prevVendor')"></td>
          <td *ngIf="displayedColumns.includes('weight')"></td>
          <td *ngIf="displayedColumns.includes('volume')"></td>
          <td *ngIf="displayedColumns.includes('skuPrice')"></td>
          <td *ngIf="displayedColumns.includes('qtySkus')"></td>
          <td *ngIf="displayedColumns.includes('subTotal')"></td>
          <td *ngIf="displayedColumns.includes('action')" class="actions">
            <dadyin-button
              [isDisabled]="!isEditable"
              (clicked)="addProductPackage()"
              [theme]="'borderless-primary'"
              type="icon"
              [typeval]="'add_circle_outline'"
            >
            </dadyin-button>
          </td>
        </tr>
      </ng-container>
      <ng-container
        [formGroup]="productPackage"
        *ngFor="let productPackage of productPackages?.controls; let i = index"
      >
        <tr>
          <td
            [attr.colspan]="16 - this.displayedColumns?.length"
            class="px-1"
            formGroupName="productDetails"
          >
            <ng-container *ngIf="!productPackage.get('productId').value">
              <input required
                (input)="getProductsList($event)"
                placeholder="Search for Product Code/Description"
                [matAutocomplete]="description"
                formControlName="description"
              />
              <mat-autocomplete
                (optionSelected)="onChange($event.option.value, productPackage)"
                autoActiveFirstOption
                #description="matAutocomplete"
              >
                <mat-option [value]="item" *ngFor="let item of productsList">
                  <span
                    style="padding: 3px"
                    class="mx-1"
                    [ngClass]="{
                      'self-product':
                        businessAccountService.getOwner(item?.audit) == 'S',
                      'third-product':
                        businessAccountService.getOwner(item?.audit) == 'T',
                      'master-product':
                        businessAccountService.getOwner(item?.audit) == 'M'
                    }"
                  >
                    ({{ businessAccountService.getOwner(item.audit) }})
                  </span>
                  {{ item.productCode }} ({{ item.description }})
                </mat-option>
              </mat-autocomplete>
            </ng-container>

            <ng-container *ngIf="productPackage.get('productId').value">
              <div class="bg-disable">
                <span
                  style="padding: 3px"
                  class="mx-1"
                  [ngClass]="{
                    'self-product':
                      businessAccountService.getOwner(
                        productPackage.get('productDetails').get('audit').value
                      ) == 'S',
                    'third-product':
                      businessAccountService.getOwner(
                        productPackage.get('productDetails').get('audit').value
                      ) == 'T',
                    'master-product':
                      businessAccountService.getOwner(
                        productPackage.get('productDetails').get('audit').value
                      ) == 'M'
                  }"
                >
                  ({{
                    businessAccountService.getOwner(
                      productPackage.get("productDetails").get("audit").value
                    )
                  }})
                </span>
                (
                {{
                  productPackage.get("productDetails").get("productCode").value
                }}
                )
                {{
                  productPackage.get("productDetails").get("description").value
                }}
              </div>
            </ng-container>
          </td>
          <td *ngIf="displayedColumns.includes('pkgs')">
            <div class="bg-disable">
              {{ productPackage?.value.productDetails?.skuPackageType }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('qtyReq')">
            <input
              class="text-center"
              (change)="calculateValues()"
              type="text"
              formControlName="quantity"
            />
          </td>
          <td *ngIf="displayedColumns.includes('qoh')">
            <div class="bg-disable">
              {{ productPackage?.value.productDetails?.qoh }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('prevPurchaseDates')">
            <div class="bg-disable">
              {{
                productPackage?.value.productDetails?.previousRFQPurchaseDate
              }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('prevQty')">
            <div class="bg-disable">
              {{ productPackage?.value.productDetails?.previousRFQQuantity }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('prevPrice')">
            <div class="bg-disable">
              {{ productPackage?.value.productDetails?.previousRFQQuantity }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('prevVendor')">
            <div class="bg-disable">
              {{ productPackage?.value.productDetails?.previousRFQVendorCode }}
            </div>
          </td>
          <td
            *ngIf="displayedColumns.includes('weight')"
            class="weight number-column"
          >
            <div class="bg-disable">
              {{
                productPackage.get("weight").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </div>
          </td>
          <td
            *ngIf="displayedColumns.includes('volume')"
            class="volume number-column"
          >
            <div class="bg-disable">
              {{
                productPackage.get("volume").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </div>
          </td>
          <td
            *ngIf="displayedColumns.includes('skuPrice')"
            class="number-column"
            formGroupName="cost"
          >
            <div
              *ngIf="!isEditable"
              class="bg-disable"
              [matTooltip]="getMetricCost(productPackage)"
            >
              {{
                productPackage.get("cost").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </div>
            <input
              (change)="changeCostByUser(productPackage)"
              *ngIf="isEditable"
              type="number"
              formControlName="attributeValue"
            />
          </td>
          <td *ngIf="displayedColumns.includes('qtySkus')" class="text-center">
            <section
              [matTooltip]="isQuantityLessThanContainerMqo(i)"
              class="bg-white my-1 d-flex align-items-center"
              style="column-gap: 2px"
            >
              <dadyin-button
                [theme]="'borderless-default'"
                type="icon"
                [typeval]="'remove'"
                (clicked)="updateProductQuantityInOrder(i, -1)"
              ></dadyin-button>
              <input
                [readonly]="!productPackage.get('productId').value"
                [matTooltip]="productPackage.value?.loadingType"
                name="quantity"
                (change)="changeQuantityInOrder(i)"
                type="number"
                min="1"
                class="text-center bg-white"
                formControlName="quantity"
              />
              <dadyin-button
                [theme]="'borderless-default'"
                type="icon"
                [typeval]="'add'"
                (clicked)="updateProductQuantityInOrder(i, 1)"
              >
              </dadyin-button>
            </section>
          </td>
          <td
            *ngIf="displayedColumns.includes('subTotal')"
            class="number-column text-center"
          >
            <div class="bg-disable">
              {{
                productPackage.get("totalCost").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </div>
          </td>
          <td *ngIf="displayedColumns.includes('action')" class="actions">
            <ng-container
              *ngIf="
                productPackages.controls?.length == i + 1 &&
                status.value != 'CONFIRMED' &&
                status.value != 'PLACED' &&
                status.value != 'REJECTED'
              "
            >
              <dadyin-button
                [isDisabled]="!isEditable"
                (clicked)="addProductPackage()"
                [theme]="'borderless-primary'"
                type="icon"
                [typeval]="'add_circle_outline'"
              >
              </dadyin-button>
            </ng-container>
            <dadyin-button
              *ngIf="
                status.value != 'CONFIRMED' &&
                status.value != 'PLACED' &&
                status.value != 'REJECTED'
              "
              [isDisabled]="!isEditable"
              (clicked)="deleteProductPackage(i)"
              [theme]="'borderless-danger'"
              type="icon"
              [typeval]="'delete_outline'"
            >
            </dadyin-button>
          </td>
        </tr>
      </ng-container>

      <ng-container>
        <tr class="bg-light b-light">
          <td [attr.colspan]="16 - this.displayedColumns?.length">
            <section class="font-size-12 w-100 text-start mx-2">
              Estimated total
              <i class="material-icon text-dark">info</i>
            </section>
          </td>

          <td *ngIf="displayedColumns.includes('pkgs')"></td>
          <td *ngIf="displayedColumns.includes('qtyReq')">
            <section class="mx-1 font-size-12 text-center text-start">
              {{ orderForm.get("totalSku").value }}
            </section>
          </td>
          <td *ngIf="displayedColumns.includes('qoh')"></td>
          <td *ngIf="displayedColumns.includes('prevPurchaseDates')"></td>
          <td *ngIf="displayedColumns.includes('prevQty')"></td>
          <td *ngIf="displayedColumns.includes('prevPrice')"></td>
          <td *ngIf="displayedColumns.includes('prevVendor')"></td>
          <td *ngIf="displayedColumns.includes('weight')">
            <section class="font-size-12 text-center">
              Wt :
              {{
                orderForm.get("weight").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </section>
          </td>
          <td *ngIf="displayedColumns.includes('volume')">
            <section class="font-size-12 text-center">
              Vol :
              {{
                orderForm.get("volume").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </section>
          </td>
          <td *ngIf="displayedColumns.includes('skuPrice')"></td>
          <td *ngIf="displayedColumns.includes('qtySkus')">
            <section class="font-size-12">
              Total SKUs :
              {{ orderForm.get("totalSku").value }}
            </section>
          </td>
          <td *ngIf="displayedColumns.includes('subTotal')">
            <section class="font-size-12">
              Sub Total :
              {{
                orderForm.get("cost").get("attributeValue").value
                  | numberFormatter : 3
              }}
            </section>
          </td>
          <td *ngIf="displayedColumns.includes('action')" class="actions"></td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<div [formGroup]="orderForm" class="row mx-auto b-round bg-white">
  <div *ngIf="type != 'rcvrfq'" class="col-md-3 col-12 p-2">
    <div class="b-round h-100">
      <div class="text-nowrap me-2">
        <div class="fw-bold font-size-14">
          Reference files :
          <dadyin-button
            [theme]="'borderless-default'"
            type="icon"
            typeval="file_upload"
            (clicked)="fileinp.click()"
            >upload</dadyin-button
          >
          <input
            (change)="uploadFiles($event.target.files, fileinp)"
            type="file"
            multiple="true"
            style="display: none !important"
            #fileinp
            accept=".pdf,.png,.jpeg,.jpg,.webp"
          />
        </div>
        <div style="max-height: 100px; overflow: auto">
          <div
            class="mt-2 font-size-12 p-1 align-items-center text-dark b-light b-round d-flex"
            *ngFor="let item of media_urls.value; let i = index"
          >
            {{ i + 1 }}. <i class="material-icon">article</i>
            <a class="mx-1" [href]="imgUrl + item.media_url" target="_blank"
              >{{ item.media_url?.substring(14) }}
            </a>
            <dadyin-button
              [theme]="'borderless-danger'"
              type="icon"
              [typeval]="'delete_outline'"
              (clicked)="deleteFile(item.media_url)"
            >
            </dadyin-button>
          </div>
        </div>
      </div>
      <div
        *ngIf="!orderFile"
        class="dashed-border mt-3 p-2"
        (drop)="fileSelected($event, 'drop', fileinp1)"
        (dragover)="onDragOver($event)"
        style="cursor: pointer; text-align: center"
      >
        <div>
          <input
            placeholder="Type Order/Document Ref. Number"
            (paste)="onPaste($event)"
            (click)="$event.stopPropagation()"
            class="w-100 bg-white mb-2"
          />
          <div class="bg-light p-1 b-round b-light" style="width: max-content">
            <dadyin-button
              [theme]="'borderless-default'"
              type="icon"
              label="Upload"
              typeval="file_upload"
              (clicked)="fileinp1.click()"
            ></dadyin-button>
            <span class="mx-1 font-size-12"> Upload </span>
          </div>
          <div class="font-size-14"></div>
        </div>

        <input
          (change)="fileSelected($event, 'normal', fileinp1)"
          type="file"
          style="display: none !important"
          #fileinp1
          accept=".pdf,.png,.jpeg,.jpg,.webp"
        />
      </div>
      <div class="mt-2 d-flex" *ngIf="orderFile">
        <div
          class="b-round b-light d-flex px-2 font-size-12 py-1 align-content-center"
        >
          {{ orderFile?.name }}
        </div>
        <dadyin-button
          [theme]="'borderless-danger'"
          type="icon"
          [typeval]="'delete_outline'"
          (clicked)="orderFile = null"
        >
        </dadyin-button>
        <dadyin-button
          [theme]="'borderless-danger'"
          type="icon"
          [typeval]="'visibility'"
        >
        </dadyin-button>
      </div>
    </div>
  </div>
  <div class="col-md-5 col-12 p-2">
    <div class="h-100">
      <div class="font-size-14">
        <b> Note </b>
      </div>
      <div class="mt-3" formGroupName="noteTemplate">
        <dadyin-select
          [optionArr]="businessAccountService.notesList"
          label="Select Note"
          formControlName="id"
          optionLabel="note_title"
          optionValue="id"
        >
        </dadyin-select>
      </div>
      <div
        class="b-light b-round font-size-12 p-3"
        style="height: 100px; overflow: auto"
      >
        {{ getNoteTitle() }}
      </div>
    </div>
  </div>
  <div *ngIf="type != 'rcvrfq'" class="col-md-4 col-12 p-2">
    <div class="card b-light h-100">
      <div class="card-header fw-bold">Order Total</div>
      <div class="process-table p-2">
        <table style="border-collapse: separate; border-spacing: 0 0.5em">
          <tbody>
            <ng-container>
              <tr>
                <td style="width: 100px" colspan="2">
                  <div style="padding-left: 10px">Discount</div>
                </td>
                <td class="width-100">
                  <div class="d-flex p-0 align-items-center">
                    <input
                      class="text-primary fw-bold text-right b-none"
                      placeholder="Enter Discount in %"
                      type="number"
                      min="0"
                      max="100"
                      (change)="
                        onChangePercentage(orderForm.get('discountPercentage'))
                      "
                      [formControl]="orderForm.get('discountPercentage')"
                    />
                    <span class="mx-1 text-primary">%</span>
                  </div>
                </td>
                <td class="number-column">
                  <div>
                    <span>
                      {{
                        orderForm.get("discountCost").get("attributeValue")
                          .value | numberFormatter : 3
                      }}
                      {{
                        orderForm.get("discountCost").get("userConversionUom")
                          .value
                      }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 150px" colspan="2">
                  <div style="padding-left: 10px">Sales Tax</div>
                </td>
                <td class="number-column width-100">
                  <div class="d-flex p-0 align-items-center">
                    <input
                      class="text-primary fw-bold text-right b-none"
                      [min]="0"
                      [max]="100"
                      placeholder="Enter Sales Tax in %"
                      (change)="
                        onChangePercentage(orderForm.get('salesTaxPercentage'))
                      "
                      type="number"
                      [formControl]="orderForm.get('salesTaxPercentage')"
                    />
                    <span class="mx-1 text-primary">%</span>
                  </div>
                </td>
                <td class="number-column">
                  <div>
                    <span>
                      {{
                        orderForm.get("salesTaxCost").get("attributeValue")
                          .value | numberFormatter : 3
                      }}
                      {{
                        orderForm.get("salesTaxCost").get("userConversionUom")
                          .value
                      }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div style="padding-left: 10px">
                    Delivery Fees
                    <i
                      class="material-icon text-dark mx-1 mt-2"
                      matTooltip="Keep your order value above $500 for Free Delivery"
                      >info</i
                    >
                  </div>
                </td>
                <td class="number-column">
                  <input
                    class="text-primary"
                    placeholder="Delivery Cost"
                    (change)="onChangeDeliveryCost()"
                    type="number"
                    [formControl]="
                      orderForm.get('deliveryCost').get('attributeValue')
                    "
                  />
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="bg-light" style="padding-left: 10px">
                    <b>Grand Total </b>
                  </div>
                </td>
                <td class="number-column">
                  <div class="bg-light">
                    <span>
                      {{
                        orderForm.get("totalCost").get("attributeValue").value
                          | numberFormatter : 3
                      }}
                      {{
                        orderForm.get("totalCost").get("userConversionUom")
                          .value
                      }}
                    </span>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
